(function(){

    //上の段スライダ―
    let swiper_feature_flag;

    let swiper_feature_top = undefined;
    let swiper_feature_topElement = document.getElementsByClassName('property-top_slider--top')[0];
    swiper_feature_topElement = swiper_feature_topElement.getElementsByClassName('currentslide')[0];
    //下の段スライダ―
    let swiper_feature_btm = undefined;
    let swiper_feature_btmElement = document.getElementsByClassName('property-top_slider--btm')[0];
    swiper_feature_btmElement = swiper_feature_btmElement.getElementsByClassName('thumbslide')[0];


    // この建物のその他の物件
    let swiper_layout = undefined;
    let swiper_layoutElement = document.getElementsByClassName('property-otherlayout_slider')[0];
    let swiper_layout_flag;

    let option_layout_sp = {
        speed: 600,
        slidesPerView: 2,
        loopedSlides: 1,
        navigation: {
            nextEl: '.property-otherlayout_next',
            prevEl: '.property-otherlayout_prev',
        },
    };

    function initSwiper() {
        var screenWidth = window.innerWidth;

        if(swiper_feature_topElement && swiper_feature_btmElement && swiper_feature_flag !== true ){
            swiper_on(swiper_feature_top);
            swiper_on(swiper_feature_btm);
            swiper_feature_btm = new Swiper(swiper_feature_btmElement,  {
                speed: 600,
                slidesPerView: 5,
                freeMode: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
            });
            swiper_feature_top = new Swiper(swiper_feature_topElement, {
                speed: 600,
                navigation: {
                    nextEl: '.property-top_next',
                    prevEl: '.property-top_prev',
                },
                thumbs: {
                    swiper: swiper_feature_btm
                }
            });
            swiper_feature_flag = true;
        }

        if(swiper_layoutElement){
            if(screenWidth < 768 && swiper_layout_flag !== 'sp') {
                swiper_on(swiper_layout);
                swiper_layout = new Swiper('.property-otherlayout_slider .swiper-container', option_layout_sp);
                swiper_layout_flag = 'sp';
            }else if(screenWidth > 767 && swiper_layout_flag !== 'pc'){
                swiper_on(swiper_layout);
                swiper_layout_flag = 'pc';
            }
        }

    }

    function swiper_on(obj_) {
        if(obj_ != undefined){
            obj_.destroy();
            obj_ = undefined;
        }else if(obj_ == undefined){
            return;
        }
    }


    var mySwiper;
    $('.modal-open').click(function(){
        var idx = parseInt($(this).attr('data-index'));
        mySwiper.slideTo(idx+1);
    });
    function initSwiper2() {

        var modalEls = document.querySelectorAll('[id^="slider-modal-"]');
        var maxHeight = 0;

        $('#slider-modal-01').show();;
        $('#slider-modal-01 .swiper-slide img').each(function () {
          //$(this).attr('width', $(this).width());
          let img = $(this);
          let imgWidth = img.width();
          let imgHeight = img.height();
          let img_class = "";
          if(imgWidth > imgHeight){
              img_class = 'wider-img';
          } else if(imgWidth <= imgHeight){
              img_class = 'taller-img';
          }
          $(this).parent().addClass(img_class);
          if ($(this).height() > maxHeight) {
            maxHeight = $(this).height();
          }
        }); 
        
        if (maxHeight > 600) {
            maxHeight = 600;
        }

        $('#slider-modal-01').hide();
    
        Array.prototype.slice.call(modalEls).forEach(function (modalEl) {
          // Swiper の初期化時、対象要素が不可視状態だとスライドの高さがうまく設定されないため一旦可視状態にする
          modalEl.style.display = 'block';
          modalEl.style.visibility = 'hidden';
          mySwiper = new Swiper(modalEl.querySelector('.swiper-container'), {
            on: {
              imagesReady: function imagesReady() {
                //this.updateAutoHeight();
                modalEl.style.display = '';
                modalEl.style.visibility = '';
                //$('#slider-modal-01 .swiper-wrapper').height(maxHeight);
                
              }
            },
            loop: true,
            speed: 800,
            /*autoHeight: true,*/
            pagination: {
              el: modalEl.querySelectorAll('.swiper-pagination')
            },
            navigation: {
              nextEl: modalEl.querySelectorAll('.swiper-button-next'),
              prevEl: modalEl.querySelectorAll('.swiper-button-prev')
            }
          });
        });
    }

    
    window.addEventListener('resize', function () {
        initSwiper();
        var timeoutID;
        return function () {
          clearTimeout(timeoutID);
          timeoutID = setTimeout(function () {
            initSwiper2();
          }, 500);
        };
    }());

    initSwiper();

    $(window).load(function(){
        initSwiper2();
    });



})();